import { IFeatureDonationQuery, useFeatureDonationQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureDonationValue {
  featureDonation: IFeatureDonationQuery['FeatureDonation'];
  featureDonationLoading: boolean;
}

export const useFeatureDonation = (): IUseFeatureDonationValue => {
  const { featureDonationId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureDonationQuery({
    variables: { featureDonationId },
    skip: !featureDonationId,
  });

  const featureDonation = data?.FeatureDonation ?? null;
  const featureDonationLoading = featureIdsLoading || loading;

  return { featureDonationLoading, featureDonation };
};
